function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#dfe4ed",
  d: "M8 16a8 8 0 118-8 8.009 8.009 0 01-8 8z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.955 11.046a.616.616 0 01-.001-.87L7.13 8 4.954 5.824a.616.616 0 01.87-.87L8 7.128l2.176-2.176a.616.616 0 01.87.87L8.87 8l2.176 2.175a.616.616 0 01-.87.87L8 8.87l-2.176 2.176a.616.616 0 01-.87 0z"
});

function SvgRemove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICAgIDxnPgogICAgICAgIDxwYXRoIGZpbGw9IiNkZmU0ZWQiIGQ9Ik0xOSAyN2E4IDggMCAxIDEgOC04IDguMDA5IDguMDA5IDAgMCAxLTggOHoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01ODIpIHRyYW5zbGF0ZSg1NzEgLTExKSIvPgogICAgICAgIDxwYXRoIGQ9Ik00LjMwOCA4LjYxNUEuNjE2LjYxNiAwIDAgMSAzLjY5MiA4VjQuOTIzSC42MTVhLjYxNS42MTUgMCAwIDEgMC0xLjIzMWgzLjA3N1YuNjE1YS42MTUuNjE1IDAgMCAxIDEuMjMxIDB2My4wNzdIOGEuNjE1LjYxNSAwIDAgMSAwIDEuMjMxSDQuOTIzVjhhLjYxNi42MTYgMCAwIDEtLjYxNS42MTV6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNTgyKSByb3RhdGUoNDUgMjkyLjY5NyA3MTMuMTQ3KSIvPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgRemove as ReactComponent };